<template>
	<div id="extract">
		<game-navbar></game-navbar>
		<div
		v-if="!isLoading"
		class="extract_content"	
		:class="{ 'incorrect' : soloGameStatus == 'giveup' || soloGameStatus == 'incorrect' ||soloGameStatus == 'timeout' }"
		>
			<!-- <div class="container"> -->
			<div class="banner" :class="soloGameStatus"
			:style="{
				'background':`linear-gradient(180deg, ${colors[colors.theme].to} 0%,  ${colors[colors.theme].from} 100%)`,
				'color': colors.theme == 'dark' ? '#fff' : '#000',
			}">
				<img v-if="soloGameStatus == 'hit'" :src="`/img/icons/extract_hit_${colors.theme}.png`" style="max-width: 100px;">
				<img v-else :src="`/img/icons/extract_wrong.png`" style="max-width: 100px;">
				<!-- <CorrectIcon v-if="soloGameStatus == 'hit'"></CorrectIcon>
				<IncorrectIcon v-if="soloGameStatus == 'giveup' || soloGameStatus == 'wrong'"></IncorrectIcon>
				<TimeoutIcon v-if="soloGameStatus == 'timeout'"></TimeoutIcon> -->
				<div class="banner_info">
					<span v-if="soloGameStatus == 'hit'">
						{{ $t("views.extract.banner_info.span1") }}
						<!-- {{ playerExtract.status }} -->
						{{ $t("views.extract.banner_info.span6") }}
					</span>
					<span v-if="soloGameStatus == 'timeout'">
						{{$t("views.extract.banner_info.span2")}}
					</span>
					<span v-if="soloGameStatus == 'giveup'">
						{{ $t("views.extract.banner_info.span3") }}
						<!-- {{ soloGameStatus }} -->
					</span>

					<span v-if="soloGameStatus == 'hit'">
						{{result.answer}}
					</span>
					<span v-if="soloGameStatus == 'timeout'">
						{{$t("views.extract.banner_info.span4")}}
					</span>
					<span v-if="soloGameStatus == 'giveup'">
						{{$t("views.extract.banner_info.span5")}}
					</span>
				</div>
			</div>
			<!-- CLARO -->
			<div class="round_info wrapper prize" 
			:style="{
				'background': colors.theme == 'dark' ? '#152935':'#fff',
				'color': colors.theme == 'dark' ? '#fff' : '#6d6c6c',
	
			}"> 
				<div class="value">
					<span>{{ $t("views.extract.value.span1") }}</span>
					<div class="points">
						<div v-if="soloGameStatus == 'hit'">
							<Coin :fill="'#0dd796'" />
							<span :style="{ color: '#0dd796' }">{{ (playerExtract.bet).toLocaleString("pt-br")  }}</span>
						</div>
						<div v-else>
							<Coin :fill="'#ff5562'" />
							<span  :style="{ color: '#ff5562' }" >0</span>
						</div>
					</div>
				</div>
			</div>
			<!-- ESCURO -->
			<div class="round_info wrapper hint" 
			:style="{
				'background': colors.theme == 'dark' ? '#0E1E2B' : '#f2f2f2',
				'color': colors.theme == 'dark' ? '#fff' : '#6d6c6c',
	
			}">
				<div class="value">
					<span>{{ $t("views.extract.value.span2") }} ({{result.hintsUsed ? result.hintsUsed : playerExtract.hints }}) </span>
					<div class="points">
						<Coin :fill="'#ff5562'" />
						<span
						:style="{
								color:'#ff5562'
							}"> {{ (playerExtract.hints * -1).toLocaleString("pt-br")  }}</span>
					</div>
				</div>
			</div>
			<!-- CLARO -->
			<div class="round_info wrapper attempts"
			:style="{
				'background': colors.theme == 'dark' ? '#152935':'#fff',
				'color': colors.theme == 'dark' ? '#fff' : '#6d6c6c',
	
			}">
				<div class="value">
					<span> {{ $t("views.extract.value.span3") }} ({{ result.attemptCount ? result.attemptCount.length : playerExtract.attempts }}) </span>
					<div class="points">
						<Coin :fill="'#ff5562'"/>
						<span
						:style="{
								color: '#ff5562'
							}"> {{ (playerExtract.attempts * -1).toLocaleString("pt-br")  }} </span>
					</div>
				</div>
			</div>
			<!-- ESCURO -->
			<div class="round_info wrapper timeDiscount" 			
			:style="{
				'background': colors.theme == 'dark' ? '#0E1E2B' : '#f2f2f2',
				'color': colors.theme == 'dark' ? '#fff' : '#6d6c6c',
	
			}">
				<div class="value">
					<span> 
						{{$t("views.extract.value.span5")}} <span class="small" >({{$t("views.extract.value.span6")}})</span>
					</span>
					<div class="points">
						<Coin :fill="'#ff5562'"/>
						<span
						:style="{
								color: '#ff5562'
							}"> {{(playerExtract.timeDiscount * - 1).toLocaleString("pt-br") }} </span>
					</div>
				</div>
			</div>
			<!-- CLARO -->
			<div class="round_info wrapper score"
			:style="{
				'background': colors.theme == 'dark' ? '#152935':'#fff',
				'color': colors.theme == 'dark' ? '#fff' : '#6d6c6c',
	
			}">
				<div class="value">
					<span class="strong"> {{ $t("views.extract.value.span4") }} </span>
					<div class="points">
						<!-- <img v-if="soloGameStatus == 'timeout' || soloGameStatus == 'giveup'" src="/img/icons/price-debit-icon.png" alt /> -->
						<!-- <Coin/>  -->
						<Coin v-if="soloGameStatus == 'hit'"  :fill="'#0dd796'"/> 
						<Coin v-else :fill="'#ff5562'"/> 

						<span v-if="soloGameStatus == 'timeout'|| soloGameStatus == 'giveup'" class="strong"
						:style="{
								color: '#ff5562'
							}"> 
							{{(playerExtract.finalBalance * -1).toLocaleString("pt-br")}}
						</span>
						<!-- <img class="win-icon" v-if="soloGameStatus == 'hit'" src="/img/icons/price-credit-win-icon.png" alt />-->
						<span v-if="soloGameStatus == 'hit'" class="strong" 
						:style="{
								color: '#0dd796'
							}">
							{{ (playerExtract.finalBalance).toLocaleString("pt-br")  }}
						</span>
					</div>
				</div>
			</div>
			<div @click="nextEnigma" class="next-enigma"
			:style="{
				'background': colors.theme == 'dark' ? '#0E1E2B' : '#f2f2f2',
				'color': colors.theme == 'dark' ? '#fff' : '#6d6c6c',
	
			}">
				<button-next :title="$t('views.extract.nextEnigma')" :arrow="true" nextRoute></button-next>
			</div>
			<feedback-game-over
				:showFeedback="feedback.showFeedback"
				:fiveMinutes="feedback.fiveMiutes"
				:attempt="feedback.attempt"
			></feedback-game-over>
		<!-- </div> -->
		</div>
		<Loader  v-else loaderStyle="circle" ></Loader>
	</div>
</template>

<script>
import Navbar from "./../components/shared/header/Navbar";
import ButtonNext from "./../components/shared/report/ButtonNext";
import FeedbackGameOver from "./../components/shared/default/FeedbackAttempt";
import IncorrectIcon from "./../components/shared/customIcons/IncorrectIcon";
import TimeoutIcon from "./../components/shared/customIcons/TimeoutIcon";
import CorrectIcon from "./../components/shared/customIcons/CorrectIcon";
import Coin from "./../components/shared/customIcons/ExtractCoin";
import Loader from "../components/shared/default/Loader"
import nextStep from '../utils/nextStep'
import { QUIZZ_EMAIL } from '../emails/quizz'
import sendEmail from "../utils/sendMail"
var moment = require("moment");
moment.locale("pt-br");

export default {
	name: "Extract",
  	components: {
		"game-navbar": Navbar,
		"feedback-game-over": FeedbackGameOver,
		ButtonNext,
		IncorrectIcon,
		CorrectIcon,
		TimeoutIcon,
		Coin,
		Loader
  	},
	props: {
		correct: {
			type: Boolean
		},
		statusExtract: {
			type: String
		}
	},
	data: function() {
		return {
			moment: moment,
			soloGameId: "",
			soloGame: {},
			isLoading: false,
			playerExtract: {
				hints: "",
				hintsPrice: 50,
				attempts: "",
				attemptsPrice: 500,
				answer: "",
				status: "",
				bet: 0,
				timeDiscount: 0,
				finalBalance: 0
			},
			soloGameStatus: "",
			result: this.$store.getters.getLastExtract,
			gameInfo: this.$store.getters.getSoloGame,
			feedback: {
				showFeedback: false,
				fiveMiutes: false,
				attempt: ""
			},
			colors: {},
			correct: false,
			sendingReport : false
		};
	},
	async created() {
		//Cálculo de tentativa
		// console.log("statusExtract: ",this.statusExtract)
		this.soloGameId = localStorage.getItem("soloGameId") || localStorage.getItem("lastSoloID")
		this.colors = JSON.parse(localStorage.getItem("colors"));
		await this.getSoloGame(this.soloGameId)
		await this.defineExtract(this.soloGame)

		// console.log("Extract Revised:", this.statusExtract);
		this.defineCorrect();
	},
	methods: {
		async nextEnigma() {
			// console.log('Game info do extrato [lenght] : ', this.gameInfo.length)
			this.isLoading = true
			if (this.gameInfo.length >= 4) {
				if(this.sendingReport) return;
				this.sendingReport = true
				await this.saveReport();
				const workspaceId = localStorage.getItem("workspaceId");
				const uid = localStorage.getItem("uid");
				const flowURL = `http://flow-manager-huddle.firebaseapp.com/dashboard?`
				if(workspaceId == "CWEERTeIge0bOSS8uapQ" || workspaceId == "amGqOVB4OsQX09WBDnv3" || workspaceId == "cA1QvjIUvYwYFWs2xnPc") {
				const flowDataId = await JSON.parse(localStorage.getItem('flowData')).id
					try {
						const scoreReq = await this.$http.get(`${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/game-sets?userId=${uid}`)
						// console.log("scoreReq: ", scoreReq)
						await nextStep(flowDataId, (scoreReq.body.fields.score - 40000))
					} catch (error) {
						//TODO: make a error message showing up instead console.log error
						// console.error("error trying to get gameSet: ", error)
					}
					return
				}
				this.$router.push({ path: "/final-score" });
				return;
			}
			this.$router.push({ path: "/" });
		},
		async saveReport() {
			let gameSetId = localStorage.getItem("gameSetId");
			const workspaceId = localStorage.getItem("workspaceId");
			let externalId = localStorage.getItem('externalId')
			let serviceKey = localStorage.getItem('serviceKey')
			let applicantId = localStorage.getItem('applicantId')
			const uid = localStorage.getItem("uid");
			const kenobyInfoId = localStorage.getItem("kenobyInfoId")
			const gupyServiceId = localStorage.getItem("gupyServiceId")
			const gupyService = JSON.parse(localStorage.getItem("gupyService"))
			const cieersInfo = JSON.parse(localStorage.getItem("cieersInfo"))
			const cieersInfoId = localStorage.getItem("cieersInfoId")
			let user = JSON.parse(localStorage.getItem("user"));
			const gupyWorkspaces = ["sPCGDV1ja9639qzApX3E", "Oj6FEicMCYo4wCoFMSOq", "ffocEYR9N4uxEDkGodO6", "OgEuM0mkkhKP4Kj85XOE","fDzf8UVa1sQ5XkMPLCGG", "Y6NunuIgvddnJ7GFvQve", "wp6SPYVblRMr8uKF4pXv"];
			const convokeToQuizzWorkspaces = ["wp6SPYVblRMr8uKF4pXv","fDzf8UVa1sQ5XkMPLCGG", "OgEuM0mkkhKP4Kj85XOE"];

			try {
				const reportResponse = await this.$http.post(`${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/reports`, {
					gameSetId,
					workspaceId,
					user: {
						name: user.name,
						email: user.email,
						cpf: user.cpf,
						id: uid
					}
				})
				// console.log("Report POST: ", reportResponse.data)
				if (gupyWorkspaces.includes(workspaceId)) {
					if(convokeToQuizzWorkspaces.includes(workspaceId)) await this.sendQuizzConvocation()
					// if(gupyService.callback_url) window.open(gupyService.callback_url, '_blank')
				}
				
				if(kenobyInfoId){
					const kenobySendResultResponse = await this.$http.post(`${process.env.VUE_APP_INTEGRATION_SYSTEM}/kenoby/send-result`, { kenobyInfoId ,gameSetId, workspaceId, user })
					// console.log("kenobySendResultResponse: ", kenobySendResultResponse.data)
					localStorage.setItem("kenobySendResultResponse", JSON.stringify(kenobySendResultResponse.data))
				}
				if(cieersInfoId){
					const cieersSendResultResponse = await this.$http.post(`${process.env.VUE_APP_INTEGRATION_SYSTEM}/cieers/send-result`, { cieersInfoId ,gameSetId })
					// console.log("cieersSendResultResponse: ", cieersSendResultResponse.data)
					localStorage.setItem("cieersSendResultResponse", JSON.stringify(cieersSendResultResponse.data))
				}
								
				if(externalId){
					let integrationReport = await this.$http.post(`${process.env.VUE_APP_INTEGRATION_SYSTEM}/vagas/send-report`, {
						gameSetId,
						externalId,
						serviceKey,
						applicantId
					})
					// console.log("integrationReport:", integrationReport)
				}
				this.$store.commit("setReport", reportResponse.data.report);				
			} catch (error) {
				//TODO: make a error message showing up instead console.log error
				// console.error("Error trying to send result: ", error)
			}
		},
		defineCorrect() {
			if (this.playerExtract.status == "correta") {
				this.correct = true;
				return;
			}
			this.correct = false;
		},
		async defineExtract(soloGame){
			// console.log("soloGame: ", soloGame)

			this.playerExtract.status = soloGame.status
			this.playerExtract.bet = soloGame.bet * 2
			soloGame.elapsedTime > 300 ? 
				this.playerExtract.timeDiscount = (soloGame.elapsedTime - 300)
				: this.playerExtract.timeDiscount = 0

			if(soloGame.attempts) soloGame.attempts.length > 3 ? 
				this.playerExtract.attempts = ((soloGame.attempts.length - 3) * this.playerExtract.hintsPrice * 1)
				: this.playerExtract.attempts = 0
			
			
			soloGame.requestedHints ? this.playerExtract.hints = (soloGame.requestedHints.length * 500) : this.playerExtract.hints = 0

			if(this.playerExtract.status === "hit") return this.playerExtract.finalBalance = this.playerExtract.bet - (this.playerExtract.timeDiscount + this.playerExtract.attempts + this.playerExtract.hints)
			// console.log("this.playerExtract.bet: ", this.playerExtract.bet)
			// console.log("this.playerExtract.timeDiscount: ", this.playerExtract.timeDiscount)
			// console.log("this.playerExtract.attempts: ", this.playerExtract.attempts)
			// console.log("this.playerExtract.hints: ", this.playerExtract.hints)
			this.playerExtract.finalBalance = this.playerExtract.timeDiscount + this.playerExtract.attempts || 0 + this.playerExtract.hints
			// console.log("this.playerExtract.finalBalance: ", this.playerExtract.finalBalance)
			
		},
		async getSoloGame(soloGameId){
			try {
				const { data: soloGameReq } = await this.$http.get(`${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/solo-games?soloGameId=${soloGameId}`)
				// console.log("soloGameReq: ", soloGameReq)
				this.soloGame = soloGameReq.soloGame
				this.soloGameStatus = this.soloGame.status
			} catch (error) {
				//TODO: make a error message showing up instead console.log error
				// console.error("error trying to get soloGame: ", error)
			}
		},
        async replace(text, substitutes){
            let textRes = text
            for (const field in substitutes) {
                textRes = textRes.replace(`[${field}]`, substitutes[field])
            }
            return textRes
        },		
		async sendQuizzConvocation(){
			const user = JSON.parse(localStorage.getItem("gupyService"))
			QUIZZ_EMAIL.body = await this.replace(QUIZZ_EMAIL.body, {
				"companyName": localStorage.getItem("workspaceTitle"),
				"name": user.name,
				"link": `https://flow-manager-huddle.firebaseapp.com/dashboard?uid=${localStorage.getItem("uid")}&workspaceId=${localStorage.getItem("workspaceId")}&gupyServiceId=${localStorage.getItem("gupyServiceId")}`
				// "endDate": moment(this.workspaceSelected.fields.endDate).format("DD [de] MMMM [de] YYYY [às] HH[h]mm")
			})
			const body = {
				"from": "no_reply.huddlebrasil.com@huddlebrasil.com",
				"to": user.email,
				"email": QUIZZ_EMAIL.body,
				"subject": "Agora é a hora do Quizz - Huddle Brasil"
			}
			// console.log("URL: ", `${process.env.VUE_FLOW}?ui=${localStorage.getItem("uid")}&workspaceId=${localStorage.getItem("workspaceId")}&gupyServiceId=${localStorage.getItem("gupyServiceId")}`)
			await sendEmail(body)
		}
	}
};
</script>

<style lang="scss">
#extract {
	height: 100%;
	// overflow: auto;
  .extract_content {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: calc(100% - 55px);
    overflow-y: auto;

    .correct, .hit {
      background-color: rgba($color: #02f0e4, $alpha: 0.25);
    }

    .banner {
      display: flex;
      align-items: center;
    //   height: 30%;
      padding:23px 5%;

      svg {
        width: 100px;
      }

      .banner_info {
        flex-direction: column;
        display: flex;
        justify-content: center;
        padding: 0 0 0 15px;
        font-weight: 600;
        letter-spacing: 1px;

        & span:nth-child(1) {
        //   color: #8a98a0;	
          text-transform: uppercase;
          font-size: 14px;
          padding: 0 0 5px 0;
		  font-weight: 500;
        }
        & span:nth-child(2) {
          font-size: 31px;
		  text-transform: capitalize;
		  font-weight: 900;
        }
      }
    }
  }
  .next-enigma {
    display: flex;
    justify-content: center;
    align-items: center;
    // position: absolute;
    // bottom: 0;
    padding: 32px 0;
    width: 100%;
    max-width: 900px;
    .btn-default {
      width: 50%;
      border: none;
      padding: 10px 0 15px;
      letter-spacing: 3px;
      text-transform: uppercase;
      font-weight: bold;
      font-size: 18px;
      color: #30353a;
      outline: none;
      border-radius: 50px;

      .arrow_right {
        width: 0;
        height: 0;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-left: 6px solid #000;
        position: absolute;
        right: 29%;
        top: 44px;
      }
    }
  }

  .round_info {
    height: 20%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 100px;

    &:nth-child(odd) {
      background-color: rgba($color: #02f0e4, $alpha: 0.1);
    }

    .strong {
      font-weight: 700;
    }

    span {
      display: flex;
      font-size: 21px;
      display: flex;
      flex-direction: column;

      .small {
        font-weight: 100;
        font-size: 13px;
        padding-top: 10px;
      }
    }

    .value {
      display: flex;
      align-items: center;
      justify-content: space-between;

	  .small{
		  font-weight: 400;
	  }

      .points {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 120px;

			span{
				font-size: 21px;
			}	

        svg {
          width: 50px;
        }

        div {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          // flex-direction: column;
          // height: 90vh;

        .correct{
            background-color: rgba($color: #02f0e4, $alpha: 0.25);
          }
		.hit {
            background-color: rgba($color: #02f0e4, $alpha: 0.25);
          }
          .banner {
            display: flex;
            align-items: center;
            height: 40%;
            padding: 0 5%;

            svg {
              width: 90px;
            }
          }
          .banner_info {
            flex-direction: column;
            display: flex;
            justify-content: center;
            padding: 0 0 0 15px;
            font-weight: 600;
            letter-spacing: 1px;

            & span:nth-child(1) {
            //   color: #8a98a0;
              text-transform: uppercase;
              font-size: 9px;
              padding: 0 0 5px 0;
            }
            & span:nth-child(2) {
              font-size: 18px;
            }
          }
        }

        .win-icon {
          max-width: 40px;
        }

        img {
          min-width: 32px;
        }
      }
    }
  }
  .score .value span, .score .value span .strong{
	font-size: 27px !important;
  }
  .score .points{
	width: 150px !important;
  }

  .incorrect {
    .banner {
      background-color: rgba($color: #ff0062, $alpha: 0.15);
    }

    .round_info {
      &:nth-child(odd) {
        background-color: rgba($color: #ff0062, $alpha: 0.05);
      }
    }
  }
}
@media only screen and (min-width: 650px) {
  #extract {
    .extract_content {
      .banner {
        .banner_info {
          span:nth-child(1) {
            font-size: 12px;
          }

          span:nth-child(2) {
            font-size: 30px;
          }
        }
      }

      .round_info {
        span {
          font-size: 17px;
        }

        .value {
          .points {
            width: 120px;
          }
        }
      }
    }
  }
}
@media only screen and (max-height: 400px) {
  #extract .extract_content .next-enigma .btn-default .arrow_right {
    top: 48px;
  }
}
@media only screen and (max-height: 900px) {
  #extract .extract_content .next-enigma .btn-default .arrow_right {
    top: 35px;
  }
  #extract .round_info.last {
    margin-bottom: 15%;
  }
}
@media only screen and (max-width: 450px){
  #extract{
    .round_info{
      &:last-child{
        margin-bottom: 40%;
      }
    }
  }
}
</style>